<script setup lang="ts">
  import { provide, useTemplateRef } from 'vue'
  import CurrencyModalAdd, {
    type ShowAddCurrencyDialogParams
  } from '../modals/CurrencyModalAdd.vue'
  import CurrencyModalDetails, {
    type ShowCurrencyDetailsDialogParams
  } from '../modals/CurrencyModalDetails.vue'
  import CurrencyModalRemove, {
    type ShowRemoveCurrencyDialogParams
  } from '../modals/CurrencyModalRemove.vue'
  import { currenciesModalsKey } from './currencies-modals'

  const modalAddCurrencyRef = useTemplateRef('modalAddCurrencyRef')
  const modalCurrencyDetailsRef = useTemplateRef('modalCurrencyDetailsRef')
  const modalRemoveCurrencyRef = useTemplateRef('modalRemoveCurrencyRef')

  const modals = {
    showAddCurrency: (params: ShowAddCurrencyDialogParams) => {
      modalAddCurrencyRef.value?.showModal(params)
    },
    showCurrencyDetails: (params: ShowCurrencyDetailsDialogParams) => {
      modalCurrencyDetailsRef.value?.showModal(params)
    },
    showRemoveCurrency: (params: ShowRemoveCurrencyDialogParams) => {
      modalRemoveCurrencyRef.value?.showModal(params)
    }
  }

  provide(currenciesModalsKey, modals)

  defineExpose(modals)
</script>
<template>
  <slot />
  <CurrencyModalAdd ref="modalAddCurrencyRef" />
  <CurrencyModalDetails ref="modalCurrencyDetailsRef" />
  <CurrencyModalRemove ref="modalRemoveCurrencyRef" />
</template>
